import { render, staticRenderFns } from "./airport_code.vue?vue&type=template&id=1152a551&scoped=true&"
import script from "./airport_code.vue?vue&type=script&lang=js&"
export * from "./airport_code.vue?vue&type=script&lang=js&"
import style0 from "./airport_code.vue?vue&type=style&index=0&id=1152a551&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1152a551",
  null
  
)

export default component.exports